document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    ".tcustomizer-customization-form"
  );
  const insertAfterElement = document.querySelector("#tee-artwork-form");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove1 = document.querySelector(".product-form-wrapper");
  const insertBeforeElement1 = document.querySelector("variant-selects");

  if (elementToMove1 && insertBeforeElement1) {
    insertBeforeElement1.before(elementToMove1);
  }
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove2 = document.querySelector("variant-selects");
  const insertBeforeElement2 = document.querySelector("#teeFormInputs");

  if (elementToMove2 && insertBeforeElement2) {
    insertBeforeElement2.parentNode.insertBefore(
      elementToMove2,
      insertBeforeElement2
    );
  }
});
